<!--
<div class="card-picture">
    <div class="card-picture__picture"
        [ngStyle]="{'background-image': content.data?.picture ? ('url(' + content.data?.picture + ((content.data?.provider?.key !== 'linkedin') ? '?size=512)' : ')')) : ('url(https://static.myskillcamp.com/lxp/images/logo-empty-state-' + content.data?.id % 7 + '.webp)')}" (click)="navigateContent()">
    </div>
    <div class="card-header">
        <div class="flex items-center space-x-2 h-full">
            <div class="card-header__logo" [style.backgroundImage]="logo"></div>
            <msc-common-avatar class="tiny"
                *ngIf="content.type === 'external_content' && !content.data?.provider && content.data?.account"
                [label]="content.data?.account.name"
                [pictureURL]="content.data?.account.picture ? (content.data?.account.picture + '?size=256') : null">
            </msc-common-avatar>
        </div>
        <msc-tag [text]="getType(content) | translate"></msc-tag>
    </div>
    <div class="card-picture__event" *ngIf="content.data?.nextEvent">
        <msc-tag [type]="'date'" [day]="content.data?.nextEvent | date: 'dd'"
            [month]="content.data?.nextEvent | localizedDate: 'MMM'" *ngIf="content.data?.nextEvent">
        </msc-tag>
    </div>
</div>
<div class="card-content">
    <div class="card-content__meta" *ngIf="content.data?.totalDuration">
        <span>{{ content.data?.totalDuration | duration }}</span>
    </div>
    <div class="card-content__state" *ngIf="content.data?.isLocked || content.data?.state || content.data?.archived">
        <ng-container *ngIf="!content.data.archived">
            <ng-container *ngIf="!content.data?.isLocked; else isLocked">
                <ng-container *ngIf="content.data?.state === 'refused'">
                    <i class="icon icon-slash"></i>
                    <span>{{ 'words.subscription-refused' | translate }}</span>
                    <span class="action" (click)="modalShowMessage.onOpen()">{{
                        'words.see-message'
                        | translate }} <i class="icon icon-arrow-right-1"></i></span>
                </ng-container>

                <ng-container *ngIf="content.data?.state === 'pending'">
                    <i class="icon icon-clock"></i>
                    <span>{{ 'words.subscription-pending' | translate }}</span>
                </ng-container>

                <ng-container
                    *ngIf="content.data?.subscribed && content.data?.state !== 'refused' && content.data?.state !== 'pending'">
                    <i class="icon icon-checkmark-circle"></i>
                    <span>{{ (!content.data.isDownloadable ? 'words.already-subscribed' :
                        'bookboon.already-downloaded') | translate }}</span>
                </ng-container>
            </ng-container>

            <ng-template #isLocked>
                <i class="icon icon-lock"></i>
                <span>{{ 'words.subscription-locked' | translate }}</span>
            </ng-template>
        </ng-container>

        <ng-container *ngIf="content.data.archived">
            <i class="icon icon-slash"></i>
            <span>{{ 'words.content-archived' | translate }}</span>
        </ng-container>
    </div>
    <div class="card-content__tags space-x-2" *ngIf="content.data?.skills && content.data?.skills.length > 0">
        <div class="tag border" *ngFor="let skill of content.data?.skills | slice:0:2"
            [tooltip]="skill.name.length > 10 ? skill.name : ''">
            <i class="icon icon-bar-chart-2"></i>
            <span>{{ skill.name }}</span>
        </div>

        <div class="tag border" *ngIf="content.data?.skills.length > 2" [tooltip]="skillList">
            <span>...</span>
        </div>
    </div>
    <h3 class="card-content__title" (click)="navigateContent()">{{ content.data?.title }}</h3>
    <div class="card-content__description">
        <p [innerHtml]="content.data?.description"></p>
    </div>
</div>
<div class="card-footer">
    <div class="card-footer__actions">
        <div class="flex space-x-2">
            <ng-container *ngIf="!content.data?.archived && !content.data?.isLocked">
                <msc-button class="msc-button--primary" icon="icon-download" palette="primary" type="fab" [tooltip]="'words.download' | translate"
                    [loading]="loading.bookboon" (click)="subscribeAndDownloadExternalContent()"
                    *ngIf="content.type !== 'external_video' && (content.type === 'external_content' && content.data?.provider) && content.data?.isDownloadable">
                </msc-button>
                <ng-container *ngIf="content.data.externalContentType !== 'audio'">
                    <msc-button [tooltip]="'words.launch' | translate" class="msc-button--primary" palette="primary"
                    type="fab" icon="icon-arrow-right"
                    *ngIf="(content.data.subscribed || content.type === 'external_video') && content.data?.state !== 'pending' && content.data?.state !== 'refused' && !content.data?.isDownloadable"
                    [loading]="loading?.trainingexpress"
                    (click)="playContent()"></msc-button>
                </ng-container>
            </ng-container>
            <msc-button class="msc-button--primary" palette="primary" type="fab" [tooltip]="'words.modify' | translate"
                *ngIf="content.data?.account?.id === me.id && content.data?.type === 'external_resource'"
                icon="icon-edit-2" (click)="editContent();">
            </msc-button>
            <msc-button *ngIf="content.data?.type != 'boclips'" class="msc-button--primary" palette="primary" type="fab" icon="icon-search"
                [tooltip]="'words.details' | translate" (click)="navigateContent()"></msc-button>
        </div>

        <div class="flex space-x-2" *ngIf="content.data?.type == 'boclips'">
            <msc-button *ngFor="let video of content.data.video" class="msc-button--primary" type="text" icon="icon-arrow-right"
                [tooltip]="'words.launch' | translate"
                (click)="openVideo(video.url)">
                {{video.resolution}}
                <span *ngIf="content.data?.format != 'PODCAST'">p</span>
                <span *ngIf="content.data?.format == 'PODCAST'">Audio</span>
            </msc-button>
        </div>

        <div *ngIf="content.data?.type != 'boclips'">
            <msc-button *ngIf="content.data?.subscribed" type="fab" (click)="deleteCourse()" icon="icon-trash-2"
                [tooltip]="(content.data?.subscriptionOrigins?.isFromGroup ? 'tooltip.delete.community.not-allowed' : 'words.unsubscribe') | translate"
                [disabled]="content.data?.subscriptionOrigins?.isFromGroup"></msc-button>
            <msc-button *ngIf="!content.data.subscribed" type="fab" [palette]="content.saved ? 'primary' : 'slate'"
                (click)="changeLearnLaterContent()" [icon]="content.saved ? 'icon-bookmark-1' : 'icon-bookmark'"
                [tooltip]="'words.bookmark' | translate"></msc-button>
        </div>
    </div>

    <div class="card-footer__progress" *ngIf="content.data?.subscribed">
        <msc-progress-bar [progress]="content.data?.progress" [color]="content.data?.progress !== 100 ? 'blue': ''">
        </msc-progress-bar>
    </div>
</div>

<msc-common-modal size="30vw" #modalShowMessage [title]="'instance.modal.refused-message.title' | translate">
    <ng-template>
        <div class="avatar-contact modal__refused--manager">
            <msc-common-avatar [label]="content.data?.validation.name"
                [pictureURL]="content.data?.validation.picture ? (content.data?.validation.picture + '?size=64') : null">
            </msc-common-avatar>
            <div class="avatar__content">
                <p class="profile__name">{{ content.data?.validation.name }}</p>
            </div>
        </div>

        <p>{{ content.data?.validation.comment }}</p>
        <div class="flex items-center mt-5 space-x-5 justify-end">
            <msc-button palette="primary" (click)="deleteCourse(true); modalShowMessage.onClose()">
                {{'common.cancel' | translate}}</msc-button>
            <msc-button class="msc-button--primary" palette="primary" (click)="modalShowMessage.onClose()">{{'common.save'
                | translate}}</msc-button>
        </div>
    </ng-template>
</msc-common-modal>

<msc-common-modal size="30vw" #modalBoclip [title]="content.data.title">
    <ng-template>
        <div class="flex items-center">
        <video #videoPlayer controls playsinline width="640" height="360">
                Your browser does not support this player.
              </video>
        </div>
        <div>
            <h3>{{'extension.infos.description-label' | translate}}</h3>
            <br>
            <p>{{content.data.description}}</p>
        </div>

    </ng-template>
</msc-common-modal>
<msc-card-manager-modal-delete-subscription #modalUnsubscribe></msc-card-manager-modal-delete-subscription>
-->

<!--plantilla skeleton-->
<div *ngIf="content.isSkeleton; else cardContent" class="card-skeleton pointer-events-none">
  <div class="skeleton-img"></div>
  <div class="skeleton-text short"></div>
  <!-- Línea 1 en dos columnas -->
  <div class="skeleton-row">
    <div class="skeleton-text short w-40"></div>
    <div class="skeleton-text short w-20"></div>
  </div>
  <!-- Línea 2 en dos columnas -->
  <div class="skeleton-row">
    <div class="skeleton-text short  w-50"></div>
    <div class="skeleton-text short w-20"></div>
  </div>
</div>

<ng-template #cardContent>
  <div id="card-course" class="hover:z-10 relative rounded-[14px] flex flex-col bg-white">

    <!-- Inner group (peer): imagen + contenido. Solo esta zona activa group-hover -->
    <div class="group peer flex flex-col">

      <!-- Imagen -->
      <div class="p-2.5 group-hover:p-0 pb-0 transition-all duration-200 cursor-pointer" (click)="navigateContent()">
        <div
          class="relative overflow-hidden rounded-[14px] transition-all duration-700 aspect-[14/8] group-hover:rounded-b-none group-hover:aspect-[16/8]">
          <img [src]="getCardPictureSrc()" (error)="$any($event.target).src = getFallbackPictureSrc()"
            class="absolute inset-0 w-full h-full object-cover" alt="">
          <div class="overlay group-hover:opacity-0"></div>
          <div class="absolute inset-0 bg-gradient-to-t from-black/30 via-black/5 to-transparent opacity-70"></div>
          <span
            class="absolute top-2 left-2 text-[10px] font-semibold px-2.5 py-0.5 rounded-xl text-white/90 backdrop-blur-sm group-hover:opacity-0 transition-opacity duration-300 bg-black/30">
            {{ 'words.' + (content?.data?.type === 'external_content' ? 'course' : content?.data?.type) | translate }}
          </span>
<button (click)="changeLearnLaterContent(); $event.stopPropagation()"
  class="absolute top-2 left-2 w-8 h-8 rounded-full flex items-center justify-center bg-black/40 opacity-0 hover:shadow-sm group-hover:opacity-100 transition-opacity duration-300 z-[4]">
  
  <i [ngClass]="content.saved ? 'icon icon-bookmark-1' : 'icon icon-bookmark'" 
     class="text-white text-sm">
  </i>
  
</button>
          <div
            class="absolute inset-0 bg-black/10  opacity-0 group-hover:opacity-100 transition-all duration-300 z-[2]">
          </div>
        </div>
      </div>

      <!-- Contenido -->
      <div class="content-card flex flex-col group-hover:gap-2.5 px-4 pt-4 pb-2 flex-1 md:gap-1 cursor-pointer"
        (click)="navigateContent()">
        <!-- Skill debajo de la imagen -->
        <div class="group-hover:hidden" *ngIf="content?.data?.skills && content?.data?.skills.length > 0">
          <div class="group-hover:hidden text-[13px] text-foreground/60 line-clamp-1">{{content?.data?.skills[0]?.name}}</div>
        </div>
        <!-- raking (normal) -->
        <div class="hidden items-center justify-between group-hover:hidden"
          *ngIf="origin !== 'bannerCreation' && origin !== 'calendarEvents'">
          <span style="min-height: 1rem;"
            class="line-clamp-1 text-[13px] text-gray-500 flex-1 min-w-0">{{content?.data?.skills[0]?.name}}</span>
          <div class="flex items-center gap-0.5 flex-shrink-0 ml-1">
            <i
              [class]="(content?.data?.rating > 0 && !content?.data?.notRated) ? 'fas fa-star text-yellow-500 text-[11px]' : 'fa-regular fa-star text-[11px] text-gray-400'"></i>
            <span class="text-[12px] text-gray-400">{{ (content?.data?.rating > 0 && !content?.data?.notRated) ?
              (content?.data?.rating | number:'1.0-1') : '0' }}</span>
          </div>
        </div>

        <!-- Titulo (normal) -->
        <div class="flex group-hover:hidden align-start justify-between">
          <div class="flex items-start space-x-1 w-100">
            <h2 class="font-semibold text-gray-900 leading-snug line-clamp-2 mb-1 min-h-[2.6em] cursor-pointer"
            [title]="content?.data?.title ? content?.data?.title : content?.title"
            [ngClass]="compact ? 'text-[14px]' : 'text-[15px] group-hover:text-base'" (click)="navigateContent()"
              [innerHTML]="content?.data?.title ? content?.data?.title : content?.title">
            </h2>
          </div>
        </div>

        <!-- Barra de progreso (normal) -->
        <div *ngIf="origin !== 'recomendation' && origin !== 'bannerCreation' && origin !== 'savedContent'"
          class="items-center flex flex-row group-hover:hidden">
          <div class="w-full">
            <div class="w-full h-1.5 rounded-full bg-gray-200">
              <div [style.width.%]="content?.data?.progress"
                [ngClass]="content?.data?.progress >= 100 ? 'bg-green-500' : 'bg-progress-gradient'"
                class="h-full rounded-full transition-all duration-500">
              </div>
            </div>
          </div>
          <ng-container *ngIf="content?.data?.progress >= 100; else progressText">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="ml-2 flex-shrink-0 text-green-500">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="m9 12 2 2 4-4"></path>
            </svg>
          </ng-container>
          <ng-template #progressText>
            <span class="ml-2 text-[12px] text-gray-500">{{content.data?.progress}}%</span>
          </ng-template>
        </div>

        <!-- Titulo (hover) -->
        <div class="hidden flex-col group-hover:flex gap-1.5">
            <div *ngIf="content?.data?.skills && content?.data?.skills.length > 0">
          <div class="text-[13px] text-foreground/60 line-clamp-1">{{content?.data?.skills[0]?.name}}</div>
        </div>

          <div class="flex align-center justify-between gap-2">
            <div class="flex items-start space-x-1 w-100">
              <h2
                class="title-card font-semibold text-gray-900 overflow-hidden text-ellipsis line-clamp-2 leading-[normal] cursor-pointer"
                [ngClass]="compact ? 'text-[14px]' : 'text-[15px]'" (click)="navigateContent()"
                [innerHTML]="content?.data?.title ? content?.data?.title : content?.title">
              </h2>
            </div>
          </div>
          <!-- Nombre del proveedor (hover) -->
          <span *ngIf="providerName" class="text-foreground/60 line-clamp-1" style="font-size: 11px;">
            {{ providerName }}
          </span>
        </div>

        <!-- Descripcion (hover) -->
        <ng-container *ngIf="origin !== 'bannerCreation' && origin !== 'calendarEvents'">
          <div class="overflow-hidden hidden group-hover:flex">
            <p class="text-gray-500 description" [ngClass]="compact ? 'text-[13px]' : 'text-[14px]'"
              [innerHTML]="content?.data?.description ? content?.data?.description : content?.description">
            </p>
          </div>
        </ng-container>

        <!-- Barra de progreso (hover) -->
        <div *ngIf="(origin !== 'recomendation' || content?.data?.subscribed) && origin !== 'bannerCreation' && origin !== 'savedContent' && content?.data?.subscribed"
          class="items-center hidden group-hover:flex" style="margin-bottom: -0.25rem; margin-top: -0.25rem;">
          <div class="w-full">
            <div class="w-full h-1.5 bg-gray-200 rounded-[14px]">
              <div [style.width.%]="content?.data?.progress || 0"
                [ngClass]="(content?.data?.progress || 0) >= 100 ? 'bg-green-500' : 'bg-progress-gradient'"
                class="h-1.5 rounded-[14px] transition-all duration-500"></div>
            </div>
          </div>
          <ng-container *ngIf="(content?.data?.progress || 0) >= 100; else hoverProgressText">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="ml-2 flex-shrink-0 text-green-500">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="m9 12 2 2 4-4"></path>
            </svg>
          </ng-container>
          <ng-template #hoverProgressText>
            <span class="ml-2 text-[12px] text-gray-500">{{content.data?.progress || 0}}%</span>
          </ng-template>
        </div>

        <!-- Tiempo y ranking (hover) -->
        <div class="justify-start items-center text-[14px] text-gray-700 gap-2 hidden group-hover:flex"
          *ngIf="origin !== 'bannerCreation' && origin !== 'calendarEvents'">
          <div class="mr-2 flex items-center space-x-1 text-gray-500" *ngIf="content.data?.duration">
            <i class="fa-regular fa-clock text-[13px] text-gray-500"></i>
            <span class="text-[13px]">{{convertSecondsToHoursMinutes(content.data?.duration)}}</span>
          </div>
          <div class="flex items-center space-x-1 text-gray-500">
            <ng-container *ngIf="!content?.data?.notRated; else notRated">
              <i class="text-[13px] fas fa-star text-yellow-500"></i>
              <span class="text-[13px] text-gray-500">{{content?.data?.rating | number:'1.0-1'}}</span>
            </ng-container>
            <ng-template #notRated>
              <i class="text-[13px] fa-regular fa-star"></i>
              <span class="text-[13px] text-gray-500">0</span>
            </ng-template>
          </div>
        </div>

        <!-- Boton full-width (hover) -->
        <div class="hidden group-hover:flex w-full pb-3"
          *ngIf="origin !== 'bannerCreation' && origin !== 'calendarEvents' && origin !== 'savedContent'">
          <ng-container *ngIf="!content.data?.archived && !content.data?.isLocked">
            <msc-button class="w-full"
              customClasses="px-1 h-7 w-full text-[13px] font-semibold py-2 rounded-full transition-all duration-300 text-white bg-secondary-500"
              palette="secondary" [loading]="loading.bookboon"
              (click)="subscribeAndDownloadExternalContent(); $event.stopPropagation()"
              *ngIf="content.type !== 'external_video' && (content.type === 'external_content' && content.data?.provider) && content.data?.isDownloadable">
              <span class="mx-2 text-[13px] ">{{'words.download' | translate}}</span>
            </msc-button>
            <ng-container *ngIf="content.data.externalContentType !== 'audio' && !content.data?.isDownloadable">
              <msc-button class="w-full"
                customClasses="px-1 h-7 w-full text-[13px] font-semibold py-2 rounded-full transition-all duration-300 text-white bg-secondary-500"
                palette="secondary" (click)="handlePlayContentAction(); $event.stopPropagation()"
                *ngIf="content.data?.subscribed">
                <span class="mx-2 text-[13px]">{{ ((content.data?.progress || 0) >= 100 ? 'words.resume' : ((content.data?.progress || 0) > 0 ? 'words.continue' : 'words.start')) | translate }}</span>
              </msc-button>
              <msc-button class="w-full"
                customClasses="rounded-full bg-gray-100 text-gray-600 px-1 h-7 w-full text-[14px] font-semibold py-2 transition-all duration-300"
                palette="secondary" (click)="navigateContent(); $event.stopPropagation()"
                *ngIf="!content.data?.subscribed">
                <span class="mx-2 text-[13px]">{{'words.see-details' | translate}}</span>
              </msc-button>
            </ng-container>
          </ng-container>
        </div>

        <!-- bannerCreation / calendarEvents -->
        <ng-container *ngIf="origin === 'bannerCreation' || origin === 'calendarEvents'">
          <msc-button class="w-full msc-button--primary" palette="secondary"
            (click)="handlePickBannerElement(); $event.stopPropagation()">
            <i class="fa-solid fa-play text-[14px]"></i>
            <span class="text-sm mx-2">{{'words.pick-course' | translate}}</span>
          </msc-button>
        </ng-container>

      </div>
    </div><!-- fin inner group peer -->

    <!-- Logo + BTN (normal): fuera del group, se oculta cuando el peer está en hover -->
    <div class="peer-hover:hidden px-4 pb-5 flex justify-between items-center text-sm text-gray-700 gap-2">
      <div class="flex items-center h-6">
        <div class="flex items-center overflow-hidden h-5">
          <div class="h-5 w-12 bg-contain object-contain bg-left bg-no-repeat" [style.background-image]="logo"
            role="img" [attr.aria-label]="content?.data?.title || 'Content logo'"></div>
        </div>
      </div>
      <ng-container *ngIf="origin !== 'bannerCreation' && origin !== 'calendarEvents' && origin !== 'savedContent'">
        <ng-container *ngIf="!content.data?.archived && !content.data?.isLocked">
          <msc-button
            customClasses="px-1 h-7 w-full text-[13px] font-semibold py-2 rounded-full transition-all duration-300 text-white bg-secondary-500"
            icon="icon-download" palette="primary" type="fab" [tooltip]="'words.download' | translate"
            [loading]="loading.bookboon" (click)="subscribeAndDownloadExternalContent(); $event.stopPropagation()"
            *ngIf="content.type !== 'external_video' && (content.type === 'external_content' && content.data?.provider) && content.data?.isDownloadable">
          </msc-button>
          <ng-container *ngIf="content.data.externalContentType !== 'audio' || !content.data?.isDownloadable">
            <msc-button
              customClasses="px-1 h-7 w-full text-[13px] font-semibold py-2 rounded-full transition-all duration-300 text-white bg-secondary-500"
              palette="secondary" (click)="handlePlayContentAction(); $event.stopPropagation()"
              *ngIf="content.data?.subscribed">
              <span class="text-[12px] mx-2">{{ ((content.data?.progress || 0) >= 100 ? 'words.resume' : ((content.data?.progress || 0) > 0 ? 'words.continue' : 'words.start')) | translate }}</span>
            </msc-button>
            <msc-button
              customClasses="rounded-full bg-gray-100 text-gray-600 px-1 h-7 w-full text-[14px] font-semibold py-2 transition-all duration-300"
              palette="secondary" (click)="navigateContent(); $event.stopPropagation()"
              *ngIf="!content.data?.subscribed && !content.data?.isDownloadable">
              <span class="text-[12px] mx-2">{{'words.see-details' | translate}}</span>
            </msc-button>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

  </div>
</ng-template>